import { Button, Result } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/AppRoutes';


// BreadCrumb
const PageNotFound: React.FC = observer(() => {
    const navigate = useNavigate();

    const handleRedirect = () => navigate(AppRoutes.DASHBOARD);

    return (
        <Result
            status="404"
            title="404"
            subTitle="Desculpe, a página que você visitou não existe."
            extra={<Button onClick={handleRedirect} type="primary">Voltar para o início</Button>}
        />
    );
});

export default PageNotFound;